import type { HTMLAttributes } from "react";

import { cn } from "@/ui/cn";

export type Tone = "neutral" | "accent" | "ok" | "warn" | "danger" | "violet";

const TONE: Record<Tone, string> = {
  neutral: "bg-sunken text-ink-2 border-line",
  accent: "bg-accent-soft text-accent border-transparent",
  ok: "bg-ok-soft text-ok border-transparent",
  warn: "bg-warn-soft text-warn border-transparent",
  danger: "bg-danger-soft text-danger border-transparent",
  violet: "bg-violet-soft text-violet border-transparent",
};

interface Props extends HTMLAttributes<HTMLSpanElement> {
  tone?: Tone;
  /** A leading dot in the tone's colour, for a status. */
  dot?: boolean;
}

export function Badge({ tone = "neutral", dot = false, className, children, ...rest }: Props) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full border px-2 py-0.5 text-xs font-medium whitespace-nowrap",
        TONE[tone],
        className,
      )}
      {...rest}
    >
      {dot ? <span aria-hidden="true" className="size-1.5 rounded-full bg-current" /> : null}
      {children}
    </span>
  );
}
